import { useQuery } from '@tanstack/react-query';

import { eventsTrailApi } from '@/domain/events/api';
import { buildTrailScopeParams } from '@/domain/events/params';
import type { TrailSource } from '@/domain/events/schemas';
import { queryOptions } from '@/services/query';
import { eventsTrailKeys } from '@/domain/events/queries/keys';

export const eventsTrailNewEventsQuery = (
  companyId: string,
  source: TrailSource,
  eventHash: string | null,
  enabled: boolean,
  entityId?: string,
) =>
  queryOptions({
    queryKey: eventsTrailKeys.newEvents(companyId, source, entityId, eventHash),
    queryFn: () =>
      eventsTrailApi.getTrailNewEvents({
        path: { source },
        query: { event_hash: eventHash ?? '', ...buildTrailScopeParams(entityId) },
      }),
    enabled: enabled && eventHash !== null,
    cacheTime: 0,
  });

export const useEventsTrailNewEvents = (
  companyId: string,
  source: TrailSource,
  eventHash: string | null,
  enabled: boolean,
  entityId?: string,
) => useQuery(eventsTrailNewEventsQuery(companyId, source, eventHash, enabled, entityId));
